import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledButtonViewContainer = styled.div`
  margin-top: 4px;
`;

export const StyledTargetGroupsModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 650px;
`;

export const StyledOrgAccordionContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 12px;
`;

export const StyledOrgAccordionOption = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 12px;
  align-items: center;
  justify-content: start;
  background-color: ${theme.colors.white};
  border-radius: 8px;
`;

export const StyledLabelAccordion = styled.div`
  display: inline-flex;
  gap: 4px;
`;
